import React from 'react';

const UniversalKnowledgeBasePanel = ({
    title,
    subtitle,
    topContent,
    children,
    rightPanelContent
}) => {
    return (
        <div className="flex h-full w-full bg-slate-50/50 p-3 gap-3 overflow-hidden">
            {/* Main Content (Left Panel) */}
            <div className="flex-1 h-full flex flex-col bg-white rounded-2xl border border-slate-200/60 shadow-sm overflow-hidden">
                {/* Header */}
                <div className="p-4 border-b border-slate-100 bg-white sticky top-0 z-10 flex justify-between items-center shrink-0">
                    <div>
                        <h2 className="font-bold text-base text-slate-800 tracking-tight">{title}</h2>
                        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
                    </div>
                </div>

                {/* Content Area */}
                <div className="flex-1 overflow-y-auto custom-scrollbar flex flex-col">
                    {topContent && (
                        <div className="p-4 pb-0">
                            {topContent}
                        </div>
                    )}
                    <div className="flex-1">
                        {children}
                    </div>
                </div>
            </div>

            {/* Right Panel */}
            {rightPanelContent && (
                <div className="w-[350px] h-full bg-white rounded-2xl border border-slate-200/60 shadow-sm overflow-hidden shrink-0 hidden xl:flex flex-col">
                    <div className="flex-1 overflow-y-auto custom-scrollbar">
                        {rightPanelContent}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UniversalKnowledgeBasePanel;
